/* ThermoAspen Stove Visuals 1.0.0
 * Realistic procedural 3D models of the catalogue stoves for the Interior and Exterior viewers, drawn from the product photographs:
 * brushed stainless / black steel, real-looking stone beds, wire stone cages with bands, glass firebox doors with fire, handles, feet.
 * Appearance only. Overall size comes from the Heater Catalogue envelope that the viewer passes in; sizes, clearances and
 * positions are never decided here. Load before the viewers. The viewers fall back to their simple block stove when this is absent.
 *
 * ThermoAspenStoveVisualsV1.build(THREE, {modelId, widthM, depthM, heightM, reg:{geo,mat,tex}}) -> THREE.Group
 *   Group origin = centre of the footprint at floor level, +Z = the front of the stove, fits widthM x heightM x depthM.
 */
(function (W) {
  'use strict';
  var VERSION = '1.0.0';
  var PI = Math.PI;

  var MODELS = {
    'harvia-the-wall-sw45': { f: 'wall' }, 'harvia-the-wall-sw60': { f: 'wall' },
    'harvia-the-wall-sw80': { f: 'wall' }, 'harvia-the-wall-sw90': { f: 'wall' },
    'harvia-cilindro-pc70': { f: 'pillar', steel: true }, 'harvia-cilindro-pc90': { f: 'pillar', steel: true },
    'harvia-legend-po70e': { f: 'pillar', steel: false }, 'harvia-legend-po110e': { f: 'pillar', steel: false },
    'harvia-spirit-sp60e': { f: 'spirit' }, 'harvia-spirit-sp90e': { f: 'spirit' },
    'harvia-linear-16': { f: 'cabinet', door: 0.56 }, 'harvia-linear-22': { f: 'cabinet', door: 0.70 },
    'harvia-m3': { f: 'cabinet', door: 0.50, m3: true },
    'harvia-cilindro-16-wood': { f: 'drum', steel: true, door: 0.40 }, 'harvia-cilindro-20-wood': { f: 'drum', steel: true, door: 0.40 },
    'harvia-legend-150': { f: 'drum', steel: false, door: 0.42 }, 'harvia-legend-240': { f: 'drum', steel: false, door: 0.52 },
    'harvia-legend-300': { f: 'drum', steel: false, door: 0.46, tall: true }
  };

  function hash(str) { var h = 2166136261, i; for (i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) { var a = seed >>> 0; return function () { a = (a + 0x6D2B79F5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }

  function supports(modelId) { return !!MODELS[modelId]; }

  function build(T, o) {
    o = o || {};
    var id = String(o.modelId || ''), spec = MODELS[id];
    if (!T || !spec) return null;
    var Wd = Math.max(.1, Number(o.widthM) || .4), Dp = Math.max(.1, Number(o.depthM) || .4), Ht = Math.max(.2, Number(o.heightM) || .7);
    var reg = o.reg || {}, rand = rng(hash(id)), group = new T.Group();
    function G(g) { if (reg.geo) reg.geo(g); return g; }
    function M(m) { if (reg.mat) reg.mat(m); return m; }
    function X(t) { if (reg.tex) reg.tex(t); return t; }
    function std(c, rough, metal, extra) { var p = { color: c, roughness: rough, metalness: metal }; if (extra) for (var k in extra) p[k] = extra[k]; return M(new T.MeshStandardMaterial(p)); }
    function canvas(w, h, draw) { var c = document.createElement('canvas'); c.width = w; c.height = h; draw(c.getContext('2d'), w, h); var t = new T.CanvasTexture(c); t.colorSpace = T.SRGBColorSpace; t.anisotropy = 4; return X(t); }

    /* ---------- materials & textures ---------- */
    var steelTex = canvas(256, 256, function (g, w, h) {
      var i, gr = g.createLinearGradient(0, 0, w, 0);
      gr.addColorStop(0, '#7d8487'); gr.addColorStop(.18, '#b4babd'); gr.addColorStop(.42, '#d3d8da'); gr.addColorStop(.7, '#9aa1a4'); gr.addColorStop(1, '#6a7174');
      g.fillStyle = gr; g.fillRect(0, 0, w, h);
      for (i = 0; i < 700; i++) { g.fillStyle = 'rgba(' + (rand() > .5 ? '255,255,255' : '70,76,80') + ',' + (.01 + rand() * .022) + ')'; g.fillRect(rand() * w, 0, .6 + rand() * 1.2, h); }
    });
    var steel = std(0xffffff, .34, .22, { map: steelTex });
    var steelDark = std(0x8d9396, .42, .3);
    var black = std(0x1c1d1f, .62, .25);
    var blackSoft = std(0x2a2b2d, .7, .15);
    var wireMat = std(spec.steel ? 0x9ea4a7 : 0x232426, spec.steel ? .4 : .55, spec.steel ? .35 : .3);
    var bandMat = std(spec.steel ? 0x969ca0 : 0x1e1f21, .5, .3, { side: T.DoubleSide });
    var grille = std(0x3a3c3f, .55, .4);
    var handleMat = std(0xd9dcde, .3, .5);
    var knobMat = std(0x141516, .4, .4);
    var glassFrameMat = std(0x121314, .5, .45);
    var fireTex = canvas(128, 128, function (g, w, h) {
      var i, bg = g.createLinearGradient(0, 0, 0, h);
      bg.addColorStop(0, '#120704'); bg.addColorStop(.45, '#3b1405'); bg.addColorStop(1, '#a8420c');
      g.fillStyle = bg; g.fillRect(0, 0, w, h);
      for (i = 0; i < 26; i++) {
        var x = w * (.12 + rand() * .76), y = h * (.58 + rand() * .42), rx = 7 + rand() * 15, ry = 18 + rand() * 44;
        var rg = g.createRadialGradient(x, y, 1, x, y, ry);
        rg.addColorStop(0, 'rgba(255,238,150,.95)'); rg.addColorStop(.35, 'rgba(255,160,40,.8)'); rg.addColorStop(1, 'rgba(200,50,0,0)');
        g.save(); g.translate(x, y); g.scale(rx / ry, 1); g.translate(-x, -y); g.fillStyle = rg; g.beginPath(); g.arc(x, y - ry * .35, ry, 0, PI * 2); g.fill(); g.restore();
      }
      for (i = 0; i < 7; i++) { g.fillStyle = 'rgba(40,18,8,' + (.55 + rand() * .3) + ')'; g.fillRect(w * (.1 + rand() * .7), h * (.86 + rand() * .06), w * (.1 + rand() * .22), h * .08); }
    });
    var fireMat = M(new T.MeshBasicMaterial({ map: fireTex, toneMapped: true }));
    var glassSheen = M(new T.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: .07, depthWrite: false }));

    /* ---------- primitives ---------- */
    function put(mesh, x, y, z, shadow) { mesh.position.set(x, y, z); mesh.castShadow = shadow !== false; mesh.receiveShadow = true; group.add(mesh); return mesh; }
    function box(w, h, d, mat, x, y, z) { return put(new T.Mesh(G(new T.BoxGeometry(w, h, d)), mat), x, y, z); }
    function cyl(rt, rb, h, mat, x, y, z, seg, open) { return put(new T.Mesh(G(new T.CylinderGeometry(rt, rb, h, seg || 32, 1, !!open)), mat), x, y, z); }
    function roundBox(w, h, d, rad, mat, x, y, z) {
      var hw = w / 2, hd = d / 2, r = Math.min(rad, hw, hd) * .98, s = new T.Shape();
      s.moveTo(-hw + r, -hd); s.lineTo(hw - r, -hd); s.quadraticCurveTo(hw, -hd, hw, -hd + r); s.lineTo(hw, hd - r); s.quadraticCurveTo(hw, hd, hw - r, hd);
      s.lineTo(-hw + r, hd); s.quadraticCurveTo(-hw, hd, -hw, hd - r); s.lineTo(-hw, -hd + r); s.quadraticCurveTo(-hw, -hd, -hw + r, -hd);
      var g = new T.ExtrudeGeometry(s, { depth: h, bevelEnabled: false, curveSegments: 6 }); g.rotateX(-PI / 2); g.translate(0, 0, 0);
      /* shape y -> -z after the rotation; the shapes used are symmetric, so the front stays +Z */
      return put(new T.Mesh(G(g), mat), x, y - h / 2 + h / 2, z);
    }
    var stoneGeo = (function () {
      var g = new T.IcosahedronGeometry(1, 1), p = g.attributes.position, i, v = {}, k, j, r2 = rng(97);
      for (i = 0; i < p.count; i++) {
        k = p.getX(i).toFixed(3) + p.getY(i).toFixed(3) + p.getZ(i).toFixed(3);
        if (!v[k]) v[k] = .78 + r2() * .42;
        j = v[k]; p.setXYZ(i, p.getX(i) * j, p.getY(i) * j * .8, p.getZ(i) * j);
      }
      g.computeVertexNormals(); return G(g);
    })();
    var stoneMat = M(new T.MeshStandardMaterial({ color: 0xffffff, roughness: .93, metalness: .02, flatShading: true }));
    function stones(list, light) {
      if (!list.length) return;
      var im = new T.InstancedMesh(stoneGeo, stoneMat, list.length), d = new T.Object3D(), c = new T.Color(), i, s, tone;
      for (i = 0; i < list.length; i++) {
        s = list[i]; d.position.set(s.x, s.y, s.z); d.rotation.set(rand() * 6.28, rand() * 6.28, rand() * 6.28);
        d.scale.set(s.r * (.9 + rand() * .35), s.r * (.7 + rand() * .3), s.r * (.9 + rand() * .35)); d.updateMatrix(); im.setMatrixAt(i, d.matrix);
        tone = rand();
        if (light === 2) c.setRGB(.22 + tone * .17, .25 + tone * .17, .3 + tone * .17); else if (light) c.setRGB(.125 + tone * .13, .13 + tone * .13, .145 + tone * .13); else c.setRGB(.05 + tone * .09, .052 + tone * .09, .058 + tone * .09);
        im.setColorAt(i, c);
      }
      im.instanceMatrix.needsUpdate = true; if (im.instanceColor) im.instanceColor.needsUpdate = true;
      im.castShadow = true; im.receiveShadow = true; group.add(im);
      G({ dispose: function () { im.dispose(); } });
    }
    function wires(radius, y0, y1, count, rad) {
      var im = new T.InstancedMesh(G(new T.CylinderGeometry(rad || .0028, rad || .0028, y1 - y0, 6)), wireMat, count), d = new T.Object3D(), i, a;
      for (i = 0; i < count; i++) { a = i / count * PI * 2; d.position.set(Math.sin(a) * radius, (y0 + y1) / 2, Math.cos(a) * radius); d.updateMatrix(); im.setMatrixAt(i, d.matrix); }
      im.instanceMatrix.needsUpdate = true; im.castShadow = false; group.add(im); G({ dispose: function () { im.dispose(); } });
    }
    function band(radius, y, h) { cyl(radius, radius, h, bandMat, 0, y, 0, 40, true); }
    /* stones filling a vertical cylinder volume (outer ring is what shows through the cage) */
    function fillCylinder(R, y0, y1, sr, skip) {
      var list = [], y, ring, n, i, a, rr, step = sr * 1.55, layer = 0, x, z;
      for (y = y0 + sr * .9; y < y1 - sr * .5; y += step, layer++) {
        for (ring = 0; ring < 3; ring++) {
          rr = ring === 0 ? R - sr * .95 : ring === 1 ? R * .52 : 0;
          n = ring === 2 ? 1 : Math.max(5, Math.floor(PI * 2 * rr / (sr * 1.75)));
          for (i = 0; i < n; i++) {
            a = (i + (layer % 2) * .5) / n * PI * 2 + rand() * .12; x = Math.sin(a) * rr; z = Math.cos(a) * rr;
            if (skip && skip(x, y, z)) continue;
            list.push({ x: x + (rand() - .5) * sr * .15, y: y + (rand() - .5) * sr * .2, z: z + (rand() - .5) * sr * .15, r: sr * (.82 + rand() * .3) });
          }
        }
      }
      return list;
    }
    function dome(R, yBase, sr, layers) {
      var list = [], l, rr, n, i, a, y;
      for (l = 0; l < layers; l++) {
        rr = Math.max(0, (R - sr * .6) * (1 - l / (layers + .6))); y = yBase + l * sr * 1.05; n = rr < sr ? 1 : Math.max(5, Math.floor(PI * 2 * rr / (sr * 1.8)));
        for (i = 0; i < n; i++) { a = i / n * PI * 2 + l; list.push({ x: n === 1 ? 0 : Math.sin(a) * rr, y: y, z: n === 1 ? 0 : Math.cos(a) * rr, r: sr * (.82 + rand() * .3) }); }
      }
      return list;
    }
    function trayStones(w, d, y0, y1, sr) {
      var list = [], x, z, y, row = 0;
      for (y = y0; y < y1; y += sr * 1.25, row++) {
        var shrink = Math.max(.35, 1 - (y - y0) / Math.max(.05, y1 - y0) * .55);
        for (x = -w / 2 * shrink + sr * .6; x <= w / 2 * shrink - sr * .6 + .001; x += sr * 1.7) for (z = -d / 2 * shrink + sr * .6; z <= d / 2 * shrink - sr * .6 + .001; z += sr * 1.7)
          list.push({ x: x + (rand() - .5) * sr * .5, y: y + (rand() - .5) * sr * .2, z: z + (rand() - .5) * sr * .5, r: sr * (.78 + rand() * .35) });
      }
      return list;
    }
    function glassDoor(wid, hei, x, y, z, frameT) {
      var f = frameT || .018;
      box(wid, hei, .02, glassFrameMat, x, y, z);
      var p = new T.Mesh(G(new T.PlaneGeometry(wid - f * 2, hei - f * 2)), fireMat); p.position.set(x, y, z + .0105); group.add(p);
      var s = new T.Mesh(G(new T.PlaneGeometry(wid - f * 2, hei - f * 2)), glassSheen); s.position.set(x, y, z + .0115); group.add(s);
      return p;
    }
    function handle(x, y, z, vertical) {
      var rod = put(new T.Mesh(G(new T.CylinderGeometry(.0065, .0065, vertical ? .07 : .06, 10)), handleMat), x, y, z + .03);
      if (!vertical) rod.rotation.z = PI / 2;
      cyl(.006, .006, .03, handleMat, x, y, z + .014, 8).rotation.x = PI / 2;
    }
    function feet(w, d, hh, round) { [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (q) { var k = round ? .7071 : 1, fx = q[0] * (w / 2 - .04) * (round ? .78 : 1) * k, fz = q[1] * (d / 2 - .04) * (round ? .78 : 1) * k; cyl(.016, .02, hh, black, fx, hh / 2, fz, 12); }); }

    /* ---------- families ---------- */
    var R, i;
    if (spec.f === 'cabinet') {
      var legH = .03, topH = Ht * .2, bodyH = Ht - legH - topH, bodyY = legH + bodyH / 2;
      feet(Wd, Dp, legH);
      if (spec.m3) {
        roundBox(Wd, bodyH, Dp, .05, black, 0, legH, 0); group.children[group.children.length - 1].position.y = legH;
        /* stainless louvred upper panel */
        for (i = 0; i < 3; i++) { var lv = box(Wd * .8, .014, .045, steel, 0, legH + bodyH * (.875 + i * .045), Dp / 2 + .006); lv.rotation.x = -.5; }
      } else {
        box(Wd, bodyH, Dp, black, 0, bodyY, 0);
        box(Wd * .96, .004, Dp * .96, blackSoft, 0, bodyY + bodyH * .22, 0);
      }
      /* top stone tray */
      var trayY = legH + bodyH;
      box(Wd, .02, Dp, black, 0, trayY + .01, 0);
      box(Wd, topH * .55, .015, black, 0, trayY + topH * .27, Dp / 2 - .0075); box(Wd, topH * .55, .015, black, 0, trayY + topH * .27, -Dp / 2 + .0075);
      box(.015, topH * .55, Dp, black, Wd / 2 - .0075, trayY + topH * .27, 0); box(.015, topH * .55, Dp, black, -Wd / 2 + .0075, trayY + topH * .27, 0);
      stones(trayStones(Wd * .9, Dp * .9, trayY + .035, Ht - .01, Math.min(.042, Wd * .1)), 0);
      /* front: large glass door, ash zone */
      var dw = Wd * spec.door * 1.25, dh = bodyH * .5;
      dw = Math.min(dw, Wd * .84);
      var dy = legH + bodyH * .64, dz = Dp / 2 + .005;
      box(dw + .03, dh + .03, .012, black, 0, dy, dz - .002);
      glassDoor(dw, dh, 0, dy, dz + .006, .02);
      handle(dw / 2 - .02, dy, dz + .016, true);
      box(dw, bodyH * .17, .012, blackSoft, 0, legH + bodyH * .17, dz);
      for (i = 0; i < 4; i++) box(dw * .7, .004, .004, grille, 0, legH + bodyH * (.12 + i * .035), dz + .008);
    } else if (spec.f === 'wall') {
      var bodyHt = Ht * .76, bx = Wd, bz = Dp;
      roundBox(bx, bodyHt, bz, .02, steel, 0, 0, 0); group.children[group.children.length - 1].position.set(0, 0, 0);
      /* black rear cover rising behind the stones */
      box(bx * .98, Ht * .98 - bodyHt * .5, .022, black, 0, bodyHt * .5 + (Ht * .98 - bodyHt * .5) / 2 - .0, -bz / 2 + .011);
      box(bx, .03, bz, black, 0, bodyHt + .0, 0);
      stones(trayStones(bx * .86, bz * .8, bodyHt + .03, Ht * .98, Math.min(.038, bx * .09)), 0);
      /* control on the left, red lamp */
      cyl(.012, .012, .008, std(0xd6322b, .4, .1, { emissive: 0x7a0c08 }), -bx / 2 + .045, bodyHt * .22, bz / 2 + .002, 14).rotation.x = PI / 2;
      cyl(.014, .014, .014, knobMat, -bx / 2 + .045, bodyHt * .48, bz / 2 + .005, 16).rotation.x = PI / 2;
    } else if (spec.f === 'pillar') {
      R = Math.min(Wd, Dp) / 2; var baseH = Ht * .22, sr = Math.max(.024, R * .2);
      cyl(R * .97, R * .97, baseH, spec.steel ? steel : std(0x3d3f42, .6, .3), 0, baseH / 2, 0, 40);
      cyl(R * .6, R * .8, .012, black, 0, .006, 0, 24);
      if (spec.steel) { box(.03, .03, .012, knobMat, -R * .3, baseH * .55, R * .96).rotation.y = 0; box(.03, .03, .012, knobMat, R * .3, baseH * .55, R * .96); }
      cyl(R * 1.0, R * 1.0, .018, wireMat, 0, baseH + .009, 0, 40);
      stones(fillCylinder(R, baseH, Ht - sr * 1.4, sr), spec.steel ? 1 : 0);
      stones(dome(R, Ht - sr * 1.4, sr, 3), spec.steel ? 1 : 0);
      wires(R, baseH, Ht - sr * .5, 30);
      band(R + .002, baseH + .01, .02); band(R + .002, baseH + (Ht - baseH) * .34, .02); band(R + .002, baseH + (Ht - baseH) * .67, .02); band(R + .002, Ht - sr * .45, .02);
    } else if (spec.f === 'drum') {
      R = Math.min(Wd, Dp) / 2; var feetH = .04, sr2 = Math.max(.03, R * .115), top = Ht, cageBot = feetH + Ht * (spec.tall ? .3 : .12);
      var doorW = Math.min(R * 2 * spec.door * 1.2, R * 1.25), doorH = Ht * (spec.tall ? .24 : .34), doorY = feetH + doorH / 2 + Ht * .1;
      var doorTop = doorY + doorH / 2 + .03;
      /* black skirt and firebox */
      cyl(R * .86, R * .9, Ht * .1, spec.steel ? steelDark : black, 0, feetH + Ht * .05, 0, 36);
      feet(R * 2, R * 2, feetH, true);
      var fz = R * .98;
      box(doorW + .06, doorH + .06, R * .35, spec.steel ? blackSoft : black, 0, doorY, fz - R * .1);
      glassDoor(doorW, doorH, 0, doorY, fz + R * .1 + .008, .024);
      handle(doorW / 2 - .02, doorY, fz + R * .1 + .02, true);
      box(doorW * .8, Ht * .06, .012, blackSoft, 0, feetH + Ht * .055, fz + R * .1);
      var skip = function (x, y, z) { return z > R * .35 && Math.abs(x) < doorW * .62 && y < doorTop + sr2 * .5; };
      var lower = fillCylinder(R, feetH + Ht * .08, Ht - sr2 * 1.5, sr2, skip);
      stones(lower, spec.steel ? 1 : 0);
      stones(dome(R, Ht - sr2 * 1.5, sr2, 3), spec.steel ? 1 : 0);
      wires(R, feetH + Ht * .1, Ht - sr2 * .3, 34);
      band(R + .003, feetH + Ht * .1, .022); band(R + .003, feetH + Ht * .46, .026); band(R + .003, feetH + Ht * .78, .026); band(R + .003, Ht - sr2 * .4, .022);
      cyl(R * 1.01, R * 1.01, .018, bandMat, 0, Ht - sr2 * .1, 0, 40, true);
      /* hide the cage wires behind the firebox front */
      void cageBot; void top;
    } else if (spec.f === 'spirit') {
      var Rx = Wd / 2, Rz = Dp / 2, y, a, list = [], n, rr, sr3 = Math.max(.03, Wd * .09), rows = 0;
      box(Wd * .5, .05, Dp * .5, black, 0, .025, 0);
      for (y = .06; y < Ht - sr3 * .5; y += sr3 * 1.45, rows++) {
        var t = (y - .05) / (Ht - .1), prof = Math.pow(Math.sin(Math.min(1, Math.max(.05, t)) * PI), .55);
        rr = prof; n = Math.max(6, Math.floor(PI * 2 * Rx * rr / (sr3 * 1.7)));
        for (i = 0; i < n; i++) {
          a = (i + (rows % 2) * .5) / n * PI * 2; var sx = Math.sin(a) * (Rx - sr3 * .7) * rr, sz = Math.cos(a) * (Rz - sr3 * .7) * rr;
          if (sz > 0 && Math.abs(sx) < Wd * .12) continue;
          list.push({ x: sx, y: y, z: sz, r: sr3 * (.84 + rand() * .3) });
        }
        list.push({ x: 0, y: y, z: -Rz * .1 * rr, r: sr3 * .9 });
      }
      stones(list, 2);
      /* black front panel and wire hoops */
      box(Wd * .22, Ht * .82, .022, black, 0, Ht * .5, Rz * .86);
      box(Wd * .05, .04, .008, std(0x8f9498, .4, .5), 0, Ht * .78, Rz * .86 + .012);
      for (i = 1; i <= 5; i++) { var tt = i / 6, rad = Math.pow(Math.sin(tt * PI), .55), hoop = new T.Mesh(G(new T.TorusGeometry(1, .0035, 5, 40)), wireMat); hoop.scale.set((Rx - sr3 * .1) * rad, (Rz - sr3 * .1) * rad, 1); hoop.rotation.x = PI / 2; put(hoop, 0, .05 + tt * (Ht - .1), 0, false); }
    }
    return group;
  }

  W.ThermoAspenStoveVisualsV1 = { version: VERSION, supports: supports, build: build, models: Object.keys(MODELS) };
})(window);
